<template>
  <span id="undo-billing-section" v-if="shouldBeDisplayed()">
    <el-button v-if="!isDropDownItem" id="btn-undo-billing" type="success" plain @click="dialogVisible = true" size="mini">
      {{ $t('customerService.shipment.undoBilling') }}
    </el-button>
    <el-dropdown-item v-if="isDropDownItem" id="close-billing-dropdown-item" @click.native="dialogVisible = true">
      <span class="more-actions-option">{{ $t('customerService.shipment.undoBilling') }}</span>
    </el-dropdown-item>
    <el-dialog
      :close-on-click-modal="false"
      v-on:open="handleOpen"
      :title="$t('customerService.shipment.undoBilling')"
      :visible.sync="dialogVisible"
      width="25%"
      class="dialog-with-cols"
      id="undo-billing-dialog"
      append-to-body
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row>
          <el-col :span="24" class="form-vertical-item">
            <el-form-item :label="$t('common.shipdate')" prop="shipDate" class="inline-input">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                v-model="form.shipDate"
                format="MM/dd/yyyy"
                :clearable="false"
                type="date">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button type="primary" id="form-undo-billing-button" @click="submitForm()" size="mini">{{ $t('customerService.shipment.undoBilling') }}</el-button>
        <el-button id="form-cancel-button" @click="dialogVisible = false" size="mini">{{ $t('common.cancel') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { Message } from 'element-ui';
import constants from '@/utils/constants';

export default {
  name: 'UndoBilling',
  props: {
    isDropDownItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['shipment']),
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        shipDate: null
      },
      formRules: {
        shipDate: [
          { required: true, message: this.$t('customerService.shipment.error.shipDateRequired'), trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    if (this.shouldBeDisplayed() && this.isDropDownItem) {
      this.$emit('displayDropdown');
    }
  },
  methods: {
    shouldBeDisplayed() {
      return this.$can(this.permissions.BILLING.UNDO_BILLING);
    },
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    async submitForm() {
      const validForm = await this.$refs.form.validate().catch(() => {});
      if (!validForm) {
        return;
      }

      Message.closeAll();
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      try {
        const response = await this.$store.dispatch('shipment/undoBilling', this.form.shipDate);
        this.$message.success(response.message);
        await this.$store.dispatch('shipment/search', {});
        this.resetForm();
        this.dialogVisible = false;
      } finally {
        loading.close();
      }
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.shipDate = this.getDefaultShipDate();
    },
    getDefaultShipDate() {
      return this.shipment.actualFilters.outboundDateFrom || moment().add(-1, 'days').toDate();
    }
  }
};
</script>
